export interface QuickAnswer {
  type: string;
  message: string;
}
export interface QuickAnswers {
  id: number;
  description: string;
  name: string;
  active: boolean;
}

export interface QuickAnswersGroups {
  id: string;
  groupId: number;
  type: string;
  message: string;
  isActivated?: boolean;
}

export interface QuickAnswersList {
  id: string;
  type: string;
  message: string;
  isActivated: boolean;
  createdDate: string;
  updatedDate: string;
}

export interface QuickAnswersRequest {
  type: string;
  message: string;
}

export interface QuickAnswersType {
  id: string;
  group: number;
}

export enum Replacements {
  USER_NAME = 'user_name',
  SELLER_NAME = 'seller_name',
  PRODUCT = 'product',
}
